import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

function move(arr, from, to) {
  arr.splice(to, 0, arr.splice(from, 1)[0]);
}

const useBlacklistFactory = ({ fetch, siteSelected: { id: siteId }, collections: { items, list }, collection: { save } }) => useMemo(() => ({
  changeSort: async (rowIdx, pos) => {
    let data = items.map((obj, idx) => [obj.id, idx])

    move(data, rowIdx, rowIdx + pos)
    data = data.filter((item, newIdx) => {
      item.push(newIdx)
      return item[1] !== item[2]
    }).map(([id, oldIdx, newIdx]) => [id, newIdx + 1])

    const result = await fetch({
      method: 'put',
      url: `blacklists/sort`,
      data,
      params: { site_id: siteId },
    });

    if (!result) {
      throw Error()
    }

    await list({})

    return result
  },
}), [fetch, siteId, items, list])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('blacklists')
  .extendHookCollectionsFactory('blacklists')
  .extend(useBlacklistFactory)
  .factory()

export {
  Provider as BlacklistProvider,
  useStore as useBlacklistStore,
}
